<!-- 头部通用组件 -->
<template>
    <div class="c-search" :class="!isHomeList ? 'c-search-nohome' : ''" ref="csearch">
        <img v-if="isHomeList" class="search-img" src="../assets/img/shield.png" alt="">
        <div v-if="isHomeList" class="search-title">北大法宝执法依据智能应用系统</div>
        <!-- 搜索框 -->
        <div class="search-bar" :class="!isHomeList ? 'search-bar-nohome' : ''">
            <div v-if="!isHomeList" class="search-bar-title" @click="handleBackHome">执法依据</div>
            <Input v-model="SearchValue" search clearable placeholder="请输入关键词" @on-search="callSearch"
                @on-keyup="recommendSearch" @on-clear="showRelate = false;">
            <Select v-model="SearchSelect" slot="prepend" @on-change="showRelate = false;">
                <Option value="causeKeyWords">事由关键词</Option>
                <Option value="lawKeyWords">法规名称</Option>
            </Select>
            <span slot="append" @click="callSearch">检索</span>
            </Input>
            <a href="javascript: void(0)" @click="openHighSearch">高级检索</a>
            <div class="relate-panel" v-if="showRelate">
                <div v-if="!showAll" class="relate-panel-five">
                    <p v-if="index < limitLength" v-for="(item, index) in RelateData" @click="selectRelateItem(item)">
                        {{ item }}</p>
                    <a href="javascript: void(0)" style="float: right;" @click="showAll = !showAll">更多</a>
                </div>
                <div v-else class="relate-panel-all" :class="showAll ? 'relate-all' : ''">
                    <p v-for="(item, index) in RelateData" @click="selectRelateItem(item)">{{ item }}</p>
                </div>
            </div>
        </div>
        <!-- 高级检索 -->
        <Modal v-if="loadDict" v-model="FormModel" width="800" class="modal-search" draggable>
            <p slot="header" style="text-align:center">
                <span>高级检索</span>
            </p>
            <Form ref="form" :model="Form" :rules="rule">
                <Row>
                    <Col span="12">
                    <FormItem label="事由关键词：">
                        <Input v-model="Form.causeKeyWords" placeholder="请输入事由关键词"></Input>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="法规名称：">
                        <Input v-model="Form.lawKeyWords" placeholder="请输入法规名称"></Input>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                    <FormItem label="事由领域：">
                        <Select v-model="Form.funcUnitType" multiple clearable>
                            <Option v-for="item in CauseFieldOption" :key="item.unitFuncTypeId"
                                :value="item.unitFuncTypeId">{{ item.unitFuncTypeName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="事由类型：">
                        <Select v-model="Form.causeType" multiple clearable>
                            <Option v-for="item in CauseTypeOption" :key="item.excuteTypeId" :value="item.excuteTypeId">
                                {{ item.excuteTypeName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="12">
                    <FormItem label="效力级别：">
                        <Select v-model="Form.effectLevel" clearable>
                            <Option v-for="item in EffLevelOption" :key="item.effectLevelId"
                                :value="item.effectLevelId">{{ item.effectLevelName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                    <Col span="12">
                    <FormItem label="法规类别：">
                        <Select v-model="Form.lawType" multiple clearable>
                            <Option v-for="item in LawTypeOption" :key="item.lawTypeId" :value="item.lawTypeId">
                                {{ item.lawTypeName }}</Option>
                        </Select>
                    </FormItem>
                    </Col>
                </Row>
                <Row>
                    <Col span="24">
                    <FormItem label="更新时间：">
                        <DatePicker v-model="TimeRange" type="datetimerange" placeholder="请选择时间："
                            @on-change="formatTime"></DatePicker>
                    </FormItem>
                    </Col>
                </Row>
            </Form>
            <div slot="footer">
                <button type="button" class="ivu-btn ivu-btn-text" @click="resetForm">重置</button>
                <button type="button" class="ivu-btn ivu-btn-primary" @click="callHighSearch">检索</button>
            </div>
        </Modal>
    </div>

</template>

<script>
    import { reqRelateSearch } from "@/api/index";
    import util from "@/plugins/util";
    export default {
        name: 'CHeader',
        components: {

        },
        props: {
            // 请求字典表结束后加装字典表
            loadDict: {
                type: Boolean,
                default() {
                    return false
                }
            },
            isHomeList: {
              type: Boolean,
              default() {
                return false
              }
            }
        },
        data() {
            return {
                FormModel: false,
                SearchValue: '',
                SearchSelect: 'causeKeyWords',
                TimeRange: [],
                Form: {
                    causeKeyWords: '',
                    lawKeyWords: '',
                    funcUnitType: [],
                    causeType: [],
                    effectLevel: '',
                    lawType: [],
                    startTime: '',
                    endTime: '',
                },
                rule: {

                },
                // 事由类型字典表
                CauseTypeOption: [],
                // 事由领域字典表
                CauseFieldOption: [],
                // 效力级别字典表
                EffLevelOption: [],
                // 法规类别字典表
                LawTypeOption: [],
                // 关联搜索列表
                RelateData: [],
                // 显示关联面板
                showRelate: false,
                // 显示全部关联
                showAll: false,
                // 显示条数
                limitLength: 5
            }
        },
        computed: {

        },
        watch: {
            // 请求字典表结束后加装字典表
            loadDict: {
                handler(data) {
                    this.loadDict = data;
                    this.CauseTypeOption = this.$store.state.causeType;
                    this.CauseFieldOption = this.$store.state.causeField;
                    this.EffLevelOption = this.$store.state.dict.xljb;
                    this.LawTypeOption = this.$store.state.dict.lawType;

                    if (Object.keys(this.$route.params).length > 0) {
                        this.Form = { ...this.Form, ...this.$route.params };
                        this.callHighSearch();
                    } else {
                        this.callSearch();
                    }
                },
            }
        },
        created() {

        },
        mounted() {
            // this.callSearch();
        },
        destroyed() {

        },
        methods: {
            handleBackHome() {
                this.$router.push({ path: '/home' });
            },
            // 功能 推荐搜索
            recommendSearch(e) {
                // 防抖处理
                if (e.keyCode != 13) {
                    util.debounce(this.getRelateData, 500)(e.target.value);
                } else {
                    this.showRelate = false;
                }
            },

            // 获取推荐数据
            getRelateData(val) {
                if (val) {
                    let searchType = '';
                    if (this.SearchSelect == 'causeKeyWords') {
                        searchType = 'cause';
                    }
                    if (this.SearchSelect == 'lawKeyWords') {
                        searchType = 'law';
                    }
                    let postData = {
                        keyWords: val,
                        type: searchType
                    }
                    reqRelateSearch(postData).then(res => {
                        if (res.ok) {
                            if (res.data.length > 0) {
                                this.showRelate = true;
                            } else {
                                this.showRelate = false;
                            }
                            if (res.data.length > 5) {
                                this.showAll = false;
                            } else {
                                this.showAll = true;
                            }
                            this.RelateData = res.data;
                        }
                    });
                } else {
                    this.showRelate = false;
                    this.RelateData = [];
                }
            },

            // 选中推荐结果
            selectRelateItem(item) {
                this.showRelate = false;
                this.SearchValue = item;
            },

            // 返回检索条件
            callSearch() {
                this.showRelate = false;
                this.RelateData = [];
                // 重置检索条件
                let params = {
                    causeKeyWords: '',
                    lawKeyWords: ''
                };
                params[this.SearchSelect] = this.SearchValue;
                this.$emit('emitSearch', params);
            },

            // 返回高级检索条件
            callHighSearch() {
                // this.$emit('emitHighSearch', this.Form);
                this.$emit('emitHighSearch', this.Form, this.buildExtendData(this.Form));
                this.FormModel = false;
            },

            // 功能 组织搜索记录数据结构
            buildExtendData(params) {
                let causeType = [];
                this.CauseTypeOption.forEach(item => {
                    params.causeType.forEach(ele => {
                        if (ele == item.excuteTypeId) {
                            causeType.push(item);
                        }
                    });
                });

                let funcUnitType = []
                this.CauseFieldOption.forEach(item => {
                    params.funcUnitType.forEach(ele => {
                        if (ele == item.unitFuncTypeId) {
                            funcUnitType.push(item);
                        }
                    });
                });

                let effectLevel = []
                this.EffLevelOption.forEach(item => {
                    if (params.effectLevel == item.effectLevelId) {
                        effectLevel.push(item);
                    }
                });

                let lawType = [];
                this.LawTypeOption.forEach(item => {
                    params.lawType.forEach(ele => {
                        if (ele == item.lawTypeId) {
                            lawType.push(item);
                        }
                    });
                });

                let result = { causeType, funcUnitType, effectLevel, lawType };
                return result;
            },

            // 功能 格式化时间为年月日时分秒
            formatTime(value) {
                this.Form.startTime = value[0];
                this.Form.endTime = value[1];
            },

            // 功能 打开高级检索面板
            openHighSearch() {
                this.FormModel = true;
            },

            // 功能 重置高级检索面板
            resetForm() {
                this.Form = {
                    causeKeyWords: '',
                    lawKeyWords: '',
                    funcUnitType: [],
                    causeType: [],
                    effectLevel: '',
                    lawType: [],
                    startTime: '',
                    endTime: '',
                };
            }
        }
    }
</script>

<style scoped>
    .c-search {
        position: relative;
        z-index: 1;
        width: 100%;
        height: 200px;
        background-color: #1867DD;
        /* background: url(../assets/img/bg.png) 0 0 no-repeat; */
        background-size: cover;
    }

    .c-search-nohome {
      height: 80px;
      background: #f7f8f8;
    }

    .search-img {
        /* display: none; */
        position: absolute;
        /* top: 8%; */
        /* left: 13%; */
        top: 14%;
        left: 10%;
        z-index: 1;
        width: 12%;
    }
    
    @media (max-width: 1920px){
      .search-img {
        top: 2%;
        left: 18%;
      }
    } 
    @media (max-width: 1600px){
      .search-img {
        top: 7%;
        left: 13%;
      }
    } 
    @media (max-width: 1440px){
      .search-img {
        top: 14%;
        left: 10%;
      }
    }

    .search-title {
        /* position: absolute; */
        /* left: 50%; */
        /* top: calc(50% - 44px); */
        /* z-index: 2; */
        /* transform: translateY(-50%); */
        /* margin-left: -400px; */
        width: 1200px;
        text-align: center;
        margin: 0 auto 0;
        padding: 30px 0 0;
        font-size: 32px;
        letter-spacing: 2px;
        color: #fff;
    }

    .search-bar {
        display: flex;
        align-items: center;
        position: absolute;
        left: 50%;
        top: calc(50% + 44px);
        z-index: 2;
        transform: translate(-50%, -50%);
        margin: -22px 0 0 56px;
        /* margin: 0 auto; */
        width: 800px;
    }

    .search-bar-nohome {
        left: 50%;
        top: 50%;
        margin: 0;
        width: 1200px;
        transform: translate(-42%, -50%);
    }

    .search-bar a {
        margin-left: 18px;
        font-size: 14px;
        color: #fff;
    }

    .search-bar-nohome a {
        margin-left: 18px;
        font-size: 14px;
        color: #1867DD;
    }

    .search-bar-title {
      margin-right: 20px;
      font-size: 20px;
      color: #1867DD;
      cursor: pointer;
    }

    .relate-panel {
        position: absolute;
        top: 50px;
        left: 120px;
        z-index: 3;
        padding: 10px 20px;
        border: 1px solid #d6d6d6;
        border-top: 0;
        width: 471px;
        background-color: #fff;
    }

    .c-search-nohome .relate-panel {
        position: absolute;
        top: 50px;
        left: 220px;
        z-index: 3;
        padding: 10px 20px;
        border: 1px solid #d6d6d6;
        border-top: 0;
        width: 631px;
        background-color: #fff;
    }

    .relate-panel p {
        margin: 16px 0;
        cursor: pointer;
    }

    .relate-all {
        overflow-y: auto;
        overflow-x: hidden;
        height: 200px;
    }

    .relate-panel .relate-panel-five a {
        color: #1867DD;
        font-size: 14px;
    }
</style>